export default "__VITE_ASSET__cede52ef__"